import type { TMessages } from '@/types/TMessages'

export const messages = {
  header: 'Правовая информация',
  annexes: {
    text: 'Перейти к приложению {numberAnnexes}',
  },
  document: {
    version: 'Версия документа {version}',
  },
} satisfies TMessages
